import { createPinia } from "pinia";

export class GlobalData {
  public static readonly Pinia = createPinia();
}